"use client";

import React, { useEffect, useRef } from 'react';
import AppImage from '@/components/ui/AppImage';

export default function StorySection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {if (e.isIntersecting) e.target.classList.remove('reveal-hidden');});
      },
      { threshold: 0.1 }
    );
    sectionRef?.current?.querySelectorAll('.reveal')?.forEach((el) => {
      el?.classList?.add('reveal-hidden');
      observer?.observe(el);
    });
    return () => observer?.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-24 px-6 bg-white">
      <div className="max-w-container mx-auto">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Images */}
          <div className="reveal relative">
            <div className="grid grid-cols-2 gap-4">
              <div className="rounded-2xl overflow-hidden h-64">
                <AppImage
                  src="https://img.rocket.new/generatedImages/rocket_gen_img_1d563938a-1773033390261.png"
                  alt="Shanghai factory production line with workers assembling daily necessities products"
                  width={400}
                  height={256}
                  className="w-full h-full object-cover" />
                
              </div>
              <div className="rounded-2xl overflow-hidden h-64 mt-8">
                <AppImage
                  src="https://img.rocket.new/generatedImages/rocket_gen_img_12ce4ac9b-1764658762607.png"
                  alt="Warehouse storage facility with organized product shelves and inventory management"
                  width={400}
                  height={256}
                  className="w-full h-full object-cover" />
                
              </div>
            </div>
            {/* Floating badge */}
            <div
              className="absolute -bottom-4 left-1/2 -translate-x-1/2 bg-white border border-brand-border rounded-2xl px-6 py-4 shadow-float text-center"
              style={{ minWidth: '200px' }}>
              
              <p className="font-heading font-bold text-primary text-3xl">2013</p>
              <p className="text-xs text-brand-muted">成立於上海</p>
            </div>
          </div>

          {/* Text */}
          <div className="reveal" style={{ transitionDelay: '120ms' }}>
            <p className="text-xs font-semibold tracking-widest uppercase text-accent mb-3">
              OUR STORY · 品牌故事
            </p>
            <h2 className="font-heading font-bold text-brand-fg mb-6" style={{ fontSize: 'clamp(1.8rem, 3vw, 2.5rem)' }}>
              從上海出發，<br />為生活增添品質
            </h2>
            <div className="space-y-4 text-brand-muted leading-relaxed">
              <p>
                信悅日用品有限公司成立於2013年，總部及工廠均位於上海。
                創始人憑借多年日用品行業經驗，深刻理解市場對高性價比、
                穩定供應鏈的迫切需求，由此創立信悅。
              </p>
              <p>
                我們自有工廠佔地超過8,000平方米，擁有完整的生產、品控、
                倉儲及物流體系。十餘年來，我們從最初的日用品單一品類，
                逐步拓展至母嬰用品、小家電、廚房用具四大核心板塊。
              </p>
              <p>
                如今，信悅已與全國500餘家批發商、零售商及電商平台建立
                長期穩定的合作關係，年出貨量超過百萬件。我們的使命是：
                <strong className="text-primary"> 工廠直供，讓品質觸手可及。</strong>
              </p>
            </div>

            {/* Milestones */}
            <div className="grid grid-cols-3 gap-4 mt-8 pt-8 border-t border-brand-border">
              {[
              { year: '2013', event: '公司成立' },
              { year: '2017', event: '拓展母嬰板塊' },
              { year: '2021', event: '電商全渠道佈局' }]?.
              map((m) =>
              <div key={m?.year} className="text-center">
                  <p className="font-heading font-bold text-primary text-xl">{m?.year}</p>
                  <p className="text-xs text-brand-muted mt-1">{m?.event}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>);

}